<template>
	<v-container class="app-progress-container" fluid fill-height>
		<v-row class="fill-height ma-0" align="center" justify="center">
			<v-col cols="12" class="d-flex flex-column align-center justify-center">
				<v-progress-circular
					indeterminate
					color="secondary-lighten-1"
					size="64"
				/>
				<div class="mt-4 text-subtitle-2">Redirecting to SSO...</div>
			</v-col>
		</v-row>

		<form
			ref="samlForm"
			method="post"
			:action="entityEndpoint"
			autocomplete="off"
		>
			<input type="hidden" :name="type" :value="context" />
			<input type="hidden" name="RelayState" :value="relayState" />
			<input type="hidden" name="Id" :value="id" />
			<input type="hidden" name="Email" :value="email" />
			<input type="hidden" name="Redirect" :value="redirect" />
		</form>
	</v-container>
</template>

<script>
export default {
	name: "SsoRedirect",
	data() {
		return {
			context: "",
			email: "",
			entityEndpoint: "",
			id: "",
			redirect: "",
			relayState: "",
			type: "",
		};
	},
	mounted() {
		this.startSso();
	},
	methods: {
		startSso() {
			this.$http
				.post("/sso-login", {
					redirect:
						typeof this.$route?.query?.redirect === "string"
							? this.$route.query.redirect
							: undefined,
				})
				.then(({ data }) => {
					this.context = data.context;
					this.entityEndpoint = data.entityEndpoint;
					this.id = data.id;
					this.redirect = this.$route?.query?.redirect;
					this.relayState = data.relayState;
					this.type = data.type;

					setTimeout(() => {
						this.$refs.samlForm.submit();
						this.context = "";
						this.entityEndpoint = "";
						this.id = "";
						this.redirect = "";
						this.relayState = "";
						this.type = "";
					}, 1);
				})
				.catch(() => {
					// If SSO init fails, fall back to welcome page
					this.$router.replace({ path: "/", query: { nosso: "1" } });
				});
		},
	},
};
</script>

<style scoped></style>
